import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const billingShadowModeBindingResponseSchema = jsonObject
export type BillingShadowModeBindingResponse = z.infer<typeof billingShadowModeBindingResponseSchema>
